import { useLocation } from 'react-router'

import { parse, ParseOptions } from 'query-string'

import { useMemoizedCall } from '@surglogs-app/hooks'

type Query = Record<string, any>

const deriveQuery = (locationSearch: string, options?: ParseOptions) => ({
  ...parse(locationSearch, { ...options }),
})

export const useRouteQuery = <T extends Query = Query>(
  locationSearch: string,
): T => useMemoizedCall(deriveQuery, [locationSearch]) as T

export const useLocationQuery = <T extends Query = Query>(
  options?: ParseOptions,
): T => {
  const location = useLocation()
  return useMemoizedCall(deriveQuery, [location.search, options]) as T
}
